/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";


export const LOG_USER_IN:string = 'LOG_USER_IN';

export const LOG_USER_OUT: string = "LOG_USER_OUT";


export type AUTHENTICATION_ACTION_TYPE = {
    type: string,
    user?: LOGGED_USER_INTERFACE | null
};


export const LOG_USER_IN_ACTION = (LOGGED_USER: LOGGED_USER_INTERFACE | null): AUTHENTICATION_ACTION_TYPE => {
    return {
        type: LOG_USER_IN,
        user: LOGGED_USER
    };
};

export const LOG_USER_OUT_ACTION = (): AUTHENTICATION_ACTION_TYPE => {
    return {
        type: LOG_USER_OUT
    };
};


export type AUTHENTICATION_STATE_TYPE = {
    loggedUser: LOGGED_USER_INTERFACE | null
};
